module.exports = __webpack_public_path__ + "static/mockups-98b46e5dbf64f2f2aaeae860d937e9e4.png";